import React, { useEffect, useState } from 'react';
import classes from "./MatchLayout2.module.css";
import moment from 'moment-timezone';
import { useNavigate } from 'react-router-dom';
import { FaCircle, FaMinus } from 'react-icons/fa6';
import { useTranslation } from 'react-i18next';

const MatchLayout2 = ({ match, match_details, key }) => {
    const navigate = useNavigate();
    const [time, setTime] = useState(null);
    const [display, setDisplay] = useState("block");

    const {t}=useTranslation();

    const matchTimer = (match_date_time) => {
        try {
            const liveTime = moment();
            const matchTime = moment.utc(match_date_time);
            const timeLeft = moment.duration(matchTime.diff(liveTime));

            if (timeLeft.asMilliseconds() <= 0) {
                console.log("Match has already started.");
                setDisplay("none");
            }

            const hours = Math.floor(timeLeft.asHours());
            const minutes = timeLeft.minutes();
            const seconds = timeLeft.seconds();

            console.log(`Match starts in ${hours}h ${minutes}m ${seconds}s`);
            // return `${hours}h ${minutes}m ${seconds}s`;
            setTime(`${hours}h ${minutes}m ${seconds}s`)
            // setExpireTime(`${hours}h ${minutes}m ${seconds}s`)
        } catch (error) {
            console.log(error, 'errro--');
        }
    }

    useEffect(() => {
        if(display!="none"){

        const intervalId = setInterval(() => {
            matchTimer(match?.match_date_time);
        }, 1000);

        return () => {
            clearInterval(intervalId);
        }
    }
    }, [display]);
    return (
        <>
            <div className={classes.match_container} key={key}>
                <div className={classes.match_heading}>
                    <p className={classes.match_title}>{match?.league_name}</p>
                </div>
                {(match_details?.fixture?.status?.short == "FT" || match_details?.fixture?.status?.short == "AET" || match_details?.fixture?.status?.short == "PEN") ? (
                    <div className={classes.match_status}>
                        <p className={classes.status_text}>{t("92")}</p>
                    </div>
                ) :
                    match_details?.fixture?.status?.short == "SUSP" ? (
                        <div className={classes.match_status}>
                            <p className={classes.status_text}>{t("93")}</p>
                        </div>
                    )
                        :
                        match_details?.fixture?.status?.short == "PST" ?
                            (
                                <div className={classes.match_status}>
                                    <p className={classes.status_text}>{t("94")}</p>
                                </div>
                            )
                            :
                            match_details?.fixture?.status?.short == "CANC" ?
                                (
                                    <div className={classes.match_status}>
                                        <p className={classes.status_text}>{t("95")}</p>
                                    </div>
                                ) :
                                (match_details?.fixture?.status?.short == "ABD" || match_details?.fixture?.status?.short == "AWD" || match_details?.fixture?.status?.short == "WO") ?
                                    (
                                        <div className={classes.match_status}>
                                            <p className={classes.status_text}>{t("96")}</p>
                                        </div>
                                    ) :
                                    match_details?.fixture?.status?.short == "1H" ? (
                                        <div className={classes.match_status}>
                                            <p className={classes.status_text}>
                                                <FaCircle className={`${classes.text_danger_glow} ${classes.blink}`}
                                                    style={{ fontSize: "8px" }}
                                                />
                                                <span style={{ marginLeft: "6px" }}>
                                                    <>{match_details?.fixture?.status?.elapsed}`</>
                                                </span>
                                            </p>
                                        </div>
                                    ) : match_details?.fixture?.status?.short == "HT" ? (
                                        <div className={classes.match_status}>
                                            <p className={classes.status_text}>
                                                <FaCircle className={`${classes.text_danger_glow} ${classes.blink}`}
                                                    style={{ fontSize: "8px" }}
                                                />
                                                <span style={{ marginLeft: "6px" }}>
                                                    {t("97")} ({match_details?.fixture?.status?.elapsed}`)
                                                </span>
                                            </p>
                                        </div>
                                    ) : match_details?.fixture?.status?.short == "2H" ? (
                                        <div className={classes.match_status}>
                                            <p className={classes.status_text}>
                                                <FaCircle className={`${classes.text_danger_glow} ${classes.blink}`}
                                                    style={{ fontSize: "8px" }}
                                                />
                                                <span style={{ marginLeft: "6px" }}>
                                                    {match_details?.fixture?.status?.elapsed}` {" "}
                                                </span>
                                            </p>
                                        </div>) : match_details?.fixture?.status?.short == "ET" ? (
                                            <div className={classes.match_status}>
                                                <p className={classes.status_text}>
                                                    <FaCircle className={`${classes.text_danger_glow} ${classes.blink}`}
                                                        style={{ fontSize: "8px" }}
                                                    />
                                                    <span style={{ marginLeft: "6px" }}>
                                                        ({match_details?.fixture?.status?.elapsed}`) {" "} ({t("98")} {match_details?.fixture?.status?.extra}`)
                                                    </span>
                                                </p>
                                            </div>) : match_details?.fixture?.status?.short == "P" ? (
                                                <div className={classes.match_status}>
                                                    <p className={classes.status_text}>
                                                        <FaCircle className={`${classes.text_danger_glow} ${classes.blink}`}
                                                            style={{ fontSize: "8px" }}
                                                        />
                                                        <span style={{ marginLeft: "6px" }}>
                                                            {t("99")} ({match_details?.fixture?.status?.elapsed}`) {" "}
                                                        </span>
                                                    </p>
                                                </div>) : null}
                <div className={classes.match_sub_container}>
                    <div className={classes.match_details}>
                        <img src={match?.home_team_image} alt={match?.home_team_name} className={classes.team_logo} />
                        <p className={classes.team_name}>{match?.home_team_name}</p>
                    </div>
                    {
                        (match_details?.fixture?.status?.short == "FT" || match_details?.fixture?.status?.short == "AET" || match_details?.fixture?.status?.short == "PEN") ? (
                            <div className={classes.score_container}>
                                <p className={classes.score}>
                                    {match_details?.goals?.home}
                                </p>
                                <div className={classes.separator}>
                                    <FaMinus className={classes.separator_icon} />
                                </div>
                                <p className={classes.score}>
                                    {match_details?.goals?.away}
                                </p>
                            </div>
                        ) : match?.match_status == "NS" ? (
                            <div className={classes.match_details}>
                                <p className={classes.match_timer}
                                style={{display}}
                                >
                                    {time}
                                </p>
                                <p className={classes.match_time}>
                                    {moment.utc(match?.match_date_time).local().format("dddd, DD MMM YYYY [at] hh:mm A")}
                                </p>
                            </div>
                        ) :
                            (match_details?.fixture?.status?.short == "1H" || match_details?.fixture?.status?.short == "HT" ||
                                match_details?.fixture?.status?.short == "2H" || match_details?.fixture?.status?.short == "ET" || match_details?.fixture?.status?.short == "P"
                                || match_details?.fixture?.status?.short == "FT" || match_details?.fixture?.status?.short == "AET" || match_details?.fixture?.status?.short == "PEN" || match_details?.fixture?.status?.short == "LIVE"
                            ) ?
                                (
                                    <div className={classes.score_container}>
                                        <p className={classes.score}>
                                            {match_details?.goals?.home}
                                        </p>
                                        <div className={classes.separator}>
                                            <FaMinus className={classes.separator_icon} />
                                        </div>
                                        <p className={classes.score}>
                                            {match_details?.goals?.away}
                                        </p>
                                    </div>
                                ) : null
                    }

                    <div className={classes.match_details}>
                        <img src={match?.away_team_image} alt={match?.away_team_name} className={classes.team_logo} />
                        <p className={classes.team_name}>{match?.away_team_name}</p>
                    </div>
                </div>

                <p className={classes.match_time} style={{ textAlign: "center", width: "100%" }}>
                    {moment.utc(match?.match_date_time).local().format("dddd, DD MMM YYYY [at] hh:mm A")}
                </p>

                <div className={classes.buttons_container}>
                    <button type='button' className={classes.fantasy_button}
                        onClick={() => {
                            navigate("/fantasy-game", {
                                state: {
                                    match_fixture_id: match?.match_fixture_id
                                }
                            })
                        }}
                    >
                        {match?.match_status == "Match Finished" ? t("107") : t("108")}
                    </button>
                    {/* <button type='button' className={classes.prediction_button}>
                                                    Predict & Win
                                                </button> */}
                </div>
            </div>
        </>
    )
}

export default MatchLayout2;